import 'components/hands/css/Slider.css';

const Slider = ({ currentSliderValue, setCurrentSliderValue }) => {
  return (
    <div className="slider-container">
      <label className="slider-label">
        Table Size: <span className="slider-value">{currentSliderValue} players</span>
      </label>
      <div className="slider-wrapper">
        <input
          type="range"
          min="2"
          max="9"
          value={currentSliderValue}
          onChange={(e) => setCurrentSliderValue(parseInt(e.target.value))}
          className="slider-input"
          style={{
            background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${((currentSliderValue - 2) / 7) * 100}%, #e5e7eb ${((currentSliderValue - 2) / 7) * 100}%, #e5e7eb 100%)`
          }}
        />
        <div className="slider-labels">
          <span>2</span>
          <span>3</span>
          <span>4</span>
          <span>5</span>
          <span>6</span>
          <span>7</span>
          <span>8</span>
          <span>9</span>
        </div>
      </div>
    </div>
  );
};

export default Slider;
